import { Popover } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';

// Salário Mínimo de Referência (R$)
export const MINIMUM_WAGE = 1621;

export const ECONOMIC_LEVEL_INFO: {
  value: string;
  label: string;
  description?: string;
  rangeDescription?: string;
}[] = [
  { value: 'NO_INCOME', label: 'Sem rendimento', description: 'Sem renda mensal' },
  { value: 'UP_TO_HALF_MW', label: 'Até 1/2 Salário Mínimo', rangeDescription: 'até R$ 810,50' },
  { value: 'ONE_TO_TWO_MW', label: '1 a 2 Salários Mínimos', rangeDescription: 'R$ 1.621 a R$ 3.242' },
  { value: 'TWO_TO_FIVE_MW', label: '2 a 5 Salários Mínimos', rangeDescription: 'R$ 3.242 a R$ 8.105' },
  { value: 'FIVE_TO_TEN_MW', label: '5 a 10 Salários Mínimos', rangeDescription: 'R$ 8.105 a R$ 16.210' },
  { value: 'TEN_TO_TWENTY_MW', label: '10 a 20 Salários Mínimos', rangeDescription: 'R$ 16.210 a R$ 32.420' },
  { value: 'ABOVE_TWENTY_MW', label: 'Acima de 20 Salários Mínimos', rangeDescription: 'acima de R$ 32.420' },
];

export const EconomicLevelInfoContent = () => (
  <div style={{ maxWidth: 300 }}>
    <p style={{ marginBottom: 12, fontWeight: 500, fontSize: 13 }}>
      Salário Mínimo de Referência: <strong>R$ {MINIMUM_WAGE.toLocaleString('pt-BR')}</strong>
    </p>
    <div style={{ fontSize: 12, lineHeight: 1.6 }}>
      {ECONOMIC_LEVEL_INFO.map((level) => (
        <div key={level.value} style={{ marginBottom: 8 }}>
          <strong style={{ color: '#2E2B81' }}>{level.label}:</strong>{' '}
          <span>{level.rangeDescription || level.description}</span>
        </div>
      ))}
    </div>
  </div>
);

export const EconomicLevelInfoIcon = () => (
  <Popover content={<EconomicLevelInfoContent />} title="Faixas de Renda" trigger={['hover', 'click']} placement="top">
    <InfoCircleOutlined style={{ marginLeft: 6, cursor: 'pointer', color: '#2E2B81', fontSize: 14 }} />
  </Popover>
);
